import { create } from 'zustand';

export const useAssociatedProductsStore = create((set, get) => ({
  // État initial
  associatedProducts: [],

  // Actions
  addAssociatedProducts: (newAssociatedProducts) =>
    set({
      associatedProducts: [
        ...get().associatedProducts,
        ...newAssociatedProducts,
      ],
    }),
  removeAssociatedProduct: (reference) =>
    set({
      associatedProducts: get().associatedProducts.filter(
        (product) => product.reference !== reference
      ),
    }),

  updateAssociatedProducts: (newAssociatedProducts) =>
    set({
      associatedProducts: [...newAssociatedProducts],
    }),

  clearAssociatedProducts: () => set({ associatedProducts: [] }),

  getAssociatedProducts: () => get().associatedProducts,

  isAssociatedProductsLoaded: () => Array.isArray(get().associatedProducts),
}));
